import "./index.css";

export default function NavigationBar() {
  return (
    <div className="header-cover position-sticky top-0 pt-3 px-4">
      <div className="px-4 py-2 bg-white common-shadow rounded-2">
        <div id="header-portal-target" className="w-100 d-flex align-items-center"></div>
      </div>
    </div>

  );
}
